module.exports = __webpack_public_path__ + "img/img-3.e876cf51.png";